module.exports = __webpack_public_path__ + "static/img/aidejiaolianIcon.e0669ffb.svg";